import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Row, Col, DatePicker, Card } from 'antd';
import Meta from 'antd/lib/card/Meta';
import { Moment } from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { RowExt } from '../../../styles';
import { DateOptionsPickerActions } from './DateOptionsActions';
import DateOptionsCard from './DateOptionsCard';

export const MaturityDatePicker = ({
  setMaturityDateLocal,
  maturityDateLocal,
  setIsPickerVisible,
}:{
  setMaturityDateLocal: (maturityDateLocal: Moment | null)=> void,
  maturityDateLocal: Moment | null,
  setIsPickerVisible: (isPickerVisible: boolean) => void,
}) => {
  const { t } = useTranslation();
  return (
    <DateOptionsCard>
      <Row>
        <Col span={16}>
          <DatePicker
            allowClear
            placeholder={t('maturityDatePicker.choose') ?? ''}
            format="DD-MM-YYYY"
            style={{ width:'100%' }}
            onChange={(value) =>
              setMaturityDateLocal(value)}
            value={maturityDateLocal}
          />
        </Col>
      </Row>
      <RowExt marginTop="bg">
        <Col span={16}>
          <Card
            title={(
              <>
                <ExclamationCircleOutlined />
                {' '}
                {t('maturityDatePicker.title') }
              </>
)}
          >
            <Meta
              description={(
                <>
                  {t('maturityDatePicker.desc1')}
                  {' '}
                  <strong>
                    {t('maturityDatePicker.desc2')}
                  </strong>
                  {' '}
                  {t('maturityDatePicker.desc3')}
                </>
        )}
            />
          </Card>
        </Col>
      </RowExt>
      <DateOptionsPickerActions
        {...{
          maturityDateLocal,
          onClose: () =>
            setIsPickerVisible(false)
        }}
      />
    </DateOptionsCard>
  );
};
